define('controllers/referafriend',['require','layout','rv!templates/member/refer-a-friend','utils','johngrid','rv!templates/partials/messenger'],function (require) {
    'use strict';
    var layout = require('layout');
    var template = require('rv!templates/member/refer-a-friend');
    var utils = require('utils');
    var JohnGrid = require('johngrid');
    return {
        /**
         * Note we allow anonymous users to view the terms and conditions
         */
        load: function (querystring) {
            this.qs = utils.deserializeQs(querystring);
            this.qs.t != null ?
                this.initRactive() :
                layout.authorize('Member,CallCenter,Admin', this.initRactive.bind(this));
        },

        initRactive: function() {
            this.loading = $.get('/api/referrals/getprogram/?id=' + this.qs.rid);
            this.loading.then(function (program) {
                this.onSubmitReferralHandler = this.onSubmitReferral.bind(this);
                this.onReferralSuccessHandler = this.onReferralSuccess.bind(this);
                this.onReferralErrorHandler = this.onReferralError.bind(this);
                this.onDataBoundHandler = this.onDataBound.bind(this);
                this.onShowTermsHandler = this.onShowTerms.bind(this);
                this.onShowProgramHandler = this.onShowProgram.bind(this);
                this.onTryExtractNameHandler = this.onTryExtractName.bind(this);
                this.ractive = layout.initRactive({
                    program: program,
                    qs: this.qs
                }, template, {
                    partials: {
                        messenger: require('rv!templates/partials/messenger')
                    }
                });
                this.ractive.on({
                    onSubmitReferral: this.onSubmitReferralHandler,
                    onShowTerms: this.onShowTermsHandler,
                    onShowProgram: this.onShowProgramHandler,
                    onTryExtractName: this.onTryExtractNameHandler
                });
                this.referralsGrid = this.setUpReferralsGrid();
                    this.$referemail = $('#referemail');
                layout.initGlobalHandlers();
            }.bind(this));
        },

        /**
         * Show past referrals and their status
         * @returns {JohnGrid}
         */
        setUpReferralsGrid: function() {
            var grid = new JohnGrid();
            grid.init($('#referrals'), null, '/api/referrals/getall');
            grid.databind();
            grid.onDataBound = this.onDataBoundHandler;
            return grid;
        },

        onSubmitReferral: function(e) {
            e.original.preventDefault();
            this.ractive.set('Errors', []);
            this.ractive.set('InfoMessages', []);
            var email = this.ractive.get('email');
            if (!this.validEmail(email)) {
                this.ractive.set('Errors', ['Please enter a valid email.']);
                return;
            }
            this.ractive.set('loading', true);
            $.postJSON('/api/referrals/create', { Email: email, ReferralProgramId: this.qs.rid, Name: this.ractive.get('name') })
             .then(this.onReferralSuccessHandler, this.onReferralErrorHandler);
        },

        onShowTerms: function(e) {
            this.qs.t = 1;
            this.changeHash(e);
        },

        onShowProgram: function(e) {
            this.qs.t = null;
            this.changeHash(e);
        },

        validEmail: function(email) {
            var emailRegex = new RegExp(window.ServerData.Regex.Email);
            return emailRegex.test(email);
        },

        /**
         * Try to extract the name from the email as they type it in, if they haven't yet filled something in
         */
        onTryExtractName: function(e) {
            if (!utils.isNullOrWhiteSpace(this.ractive.get('name'))) {
                return;
            }
            var email = this.ractive.get('email');
            if (!this.validEmail(email)) {
                return;
            }
            var potentialName = email.replace(/@.*$/, '').replace(/[\.\-]/g, ' ').toTitleCase(); //get rid of everything after '@', then replace '.' and '-' with ' ', then title case it.
            this.ractive.set('name', potentialName);
        },

        changeHash: function (e) {
            e.original.preventDefault();
            window.location.hash = '/refer-a-friend/{0}'.format(utils.serializeQs(this.qs));
        },

        onReferralSuccess: function(response) {
            this.ractive.set('InfoMessages', ['Successfully submitted your referral for {0}! We\'ve sent them an email, but if they don\'t receive the email, send them this link: {1}'.format(this.ractive.get('email'), response)]);
            this.ractive.set('email', '');
            this.ractive.set('name', '');
            this.ractive.set('loading', false);
            this.referralsGrid.databind();
        },

        onReferralError: function (xhr) {
            var errors = window.Utilities.getFriendlyErrors(xhr);
            this.ractive.set('Errors', errors.length > 0 ? errors : ['An error occurred while submitting your referral. Please try again or contact member support for assistance.']);
            this.ractive.set('loading', false);
        },

        onDataBound:  function() {
            this.ractive.set('showgrid', this.referralsGrid.currentDataSource.length > 0);
        },

        unload: function() {
            if (this.ractive != null) {
                this.ractive.teardown();
            }
            if (this.referralsGrid != null) { this.referralsGrid.unload(); }
            this.onSubmitReferralHandler = null;
            this.onReferralSuccessHandler = null;
            this.onReferralErrorHandler = null;
            this.onDataBoundHandler = null;
            this.onShowTermsHandler = null;
            this.onShowProgramHandler = null;
            this.onTryExtractNameHandler = null;
            this.$referemail = null;
            this.qs = null;
        }
    };
});

